<script setup>
import { useRouter } from "vue-router";

const router = useRouter();
const toLink = (url) => {
  router.push(url);
};
</script>

<template>
  <v-footer class="footercontainer" padless>
    <v-row no-gutters>
      <span color="black" class="footer" @click="toLink('/documentinvite')">参加者募集</span>
      <span color="black" class="footer" @click="toLink('/term')">利用規約</span>
      <span color="black" class="footer" @click="toLink('/privacypolicy')"
        >プライバシーポリシー</span
      >
      <span color="black" class="footer" @click="toLink('/inquiry')">お問い合わせ</span>
      <span color="black" class="footer" @click="toLink('/company')">会社概要</span>
      <span color="black" class="footer" @click="toLink('/tokushoho')"
        >特定商取引法に関する表記</span
      >
      <span color="black" class="footer" @click="toLink('/faq')">よくある質問</span>
      <span color="black" class="footer" @click="toLink('/academy')">SukiSukiアカデミー</span>
      <v-col class="copyright" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>Random Factory Inc.</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style scoped>
.footercontainer {
  display: flex;
  flex-wrap: wrap;
  background-color: rgba(240, 172, 196);
  padding: 30px 0 30px 0;
}
.footer {
  /* color: white; */
  font-size: 10px;
  width: calc(100% / 3);
  cursor: pointer;
}
.copyright {
  /* color: white; */
  font-size: 10px;
  width: 100%;
  margin: 30px 0 0 0;
}
</style>
